import { render, staticRenderFns } from "./teachersEvaluate.vue?vue&type=template&id=af54547c&scoped=true"
import script from "./teachersEvaluate.vue?vue&type=script&lang=js"
export * from "./teachersEvaluate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af54547c",
  null
  
)

export default component.exports